import { $ } from "./dom"

export class Widget {
  constructor(root = document.body) {
    this.root = typeof root === "string" ? document.querySelector(root) : root
    this.listeners = []
  }

  $(selector) {
    return selector ? $(this.root).find(selector) : $(this.root)
  }

  delegate(eventName, selector, handler) {
    const listener = (event) => {
      const target = event.target.closest(selector)
      if (target && this.root.contains(target)) handler.call(this, event, target)
    }
    this.root.addEventListener(eventName, listener)
    this.listeners.push([eventName, listener])
  }

  remove() {
    this.listeners.forEach(([eventName, listener]) => this.root.removeEventListener(eventName, listener))
    this.listeners = []
  }
}

export class Emitter {
  constructor() {
    this.events = new Map()
  }

  on(name, callback, context) {
    const callbacks = this.events.get(name) || []
    callbacks.push({ callback, context })
    this.events.set(name, callbacks)
    return this
  }

  off() {
    this.events.clear()
  }

  emit(name, ...args) {
    ;(this.events.get(name) || []).forEach(({ callback, context }) => callback.apply(context || this, args))
  }
}
